import { ShopifyIntegration } from "@redotech/redo-model/shopify";
import { GetTeam, Team } from "@redotech/redo-model/team";
import { createContext } from "react";

export type TeamContextValue =
  | (Team & {
      featureFlags: GetTeam["featureFlags"];
      platform: "shopify" | "commerce-cloud" | "commentsold" | "bigcommerce";
      shopifyIntegration?: ShopifyIntegration;
      updatePermissionsLink?: string;
      ianaTimezone: string;
    })
  | undefined;
export const TeamContext = createContext<TeamContextValue>(undefined);

export const ReloadTeamContext = createContext<(() => void) | undefined>(
  undefined,
);
